import { render, staticRenderFns } from "./StudioFeature.vue?vue&type=template&id=acdca85a&scoped=true&"
import script from "./StudioFeature.vue?vue&type=script&lang=js&"
export * from "./StudioFeature.vue?vue&type=script&lang=js&"
import style0 from "./StudioFeature.vue?vue&type=style&index=0&id=acdca85a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdca85a",
  null
  
)

export default component.exports